import { startCase } from 'lodash-es'
import { getConsignmentStatus } from '~/entities/consignment'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { Chip } from '~/shared/ui'

export function StatusChip({
  status,
  hasReviewer,
}: {
  status: apiClient.ReviewStatusEnum
  hasReviewer: boolean
}) {
  const documentStatus = getConsignmentStatus({ status, hasReviewer })

  return (
    <Chip
      rounded
      info={documentStatus === 'inProgress'}
      success={documentStatus === 'finished'}
      warning={documentStatus === 'awaiting'}
      disabled={documentStatus === 'rejected'}
    >
      {startCase(documentStatus)}
    </Chip>
  )
}
